var exports = {
  "kL": "DiscoverySearchFilters.module__container___LWc0MW",
  "uW": "DiscoverySearchFilters.module__section___LWc0MW",
  "SF": "DiscoverySearchFilters.module__sectionHeading___LWc0MW",
  "jv": "DiscoverySearchFilters.module__categoryList___LWc0MW",
  "af": "DiscoverySearchFilters.module__categoryItem___LWc0MW",
  "Cm": "DiscoverySearchFilters.module__categoryItemActive___LWc0MW",
  "Jm": "DiscoverySearchFilters.module__categoryLabel___LWc0MW",
  "_E": "DiscoverySearchFilters.module__categoryCount___LWc0MW",
};

module.exports = exports;
